import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { ApiStatus } from "../../utils/api.types";
import { fetchGRNs, fetchGRNById, addGRN, updateGRN, postGRN, cancelGRN, reverseGRN } from "./grnThunk";

interface GRNSliceState {
  grns: any[];
  grnDetails: any;
  rowCount: number;
  status: ApiStatus;
  errorMessage?: string;
}

const initialState: GRNSliceState = { grns: [], grnDetails: {}, rowCount: 0, status: ApiStatus.IDLE, errorMessage: "" };

const grnSlice = createSlice({
  name: "grn",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGRNs.pending, (state) => { state.status = ApiStatus.LOADING; })
      .addCase(fetchGRNs.fulfilled, (state, action: any) => {
        state.status = ApiStatus.SUCCESS;
        // Server-side paginated: { data, total }. Falls back to a plain array for safety.
        const p = action.payload;
        state.grns = Array.isArray(p) ? p : p?.data || [];
        state.rowCount = Array.isArray(p) ? p.length : p?.total || 0;
      })
      .addCase(fetchGRNs.rejected, (state, action) => { state.status = ApiStatus.FAILED; state.errorMessage = action.error.message; })

      .addCase(fetchGRNById.fulfilled, (state, action: any) => { state.grnDetails = action.payload || {}; })

      .addCase(addGRN.fulfilled, (state, action: any) => { toast.success("GRN created"); state.grnDetails = action.payload || {}; })
      .addCase(addGRN.rejected, (state, action) => { toast.error(action.error.message || "Failed to create GRN"); })

      .addCase(updateGRN.fulfilled, () => { toast.success("GRN updated"); })
      .addCase(updateGRN.rejected, (state, action) => { toast.error(action.error.message || "Failed to update GRN"); })

      .addCase(postGRN.fulfilled, (state, action: any) => { toast.success(`GRN posted (${action.payload?.movementCount ?? 0} movements)`); })
      .addCase(postGRN.rejected, (state, action) => { toast.error(action.error.message || "Failed to post GRN"); })

      .addCase(cancelGRN.fulfilled, () => { toast.success("GRN cancelled"); })
      .addCase(cancelGRN.rejected, (state, action) => { toast.error(action.error.message || "Failed to cancel GRN"); })

      .addCase(reverseGRN.fulfilled, (state, action: any) => { toast.success(`GRN reversed (${action.payload?.reversedCount ?? 0} movements)`); })
      .addCase(reverseGRN.rejected, (state, action) => { toast.error(action.error.message || "Failed to reverse GRN"); });
  },
});

export default grnSlice.reducer;
